import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/bbleap.webp';
import screenshot_target from '../../../images/letterfunnel/luistelo.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Luis Telo"
      firstname="Luis"
      companyname="BBleap"
      competition="Raven Industries en WEED-IT"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/luistelo.js